import { CartActionTypes, CartState } from '../types';
import { IOrderProduct } from '../../types/orderProduct';

const initialState: CartState = {
  items: JSON.parse(localStorage.getItem('items') || '[]'),
};

export default function (state = initialState, action: CartActionTypes): CartState {
  switch (action.type) {
    case 'UPSERT_PRODUCT': {
      let items = state.items;
      if (items.find((item) => item.id === action.payload.productOrder.id)) {
        items = items.map((item) => {
          if (item.id === action.payload.productOrder.id) {
            item.quantity += action.payload.productOrder.quantity;
          }
          return item;
        });
      } else {
        items.push(action.payload.productOrder);
      }
      localStorage.setItem('items', JSON.stringify(items));
      return {
        ...state,
        items,
      };
    }
    case 'REMOVE_PRODUCT': {
      const items = state.items.filter((item) => item.id !== action.payload.productOrderId);

      localStorage.setItem('items', JSON.stringify(items));
      return {
        ...state,
        items,
      };
    }

    case 'EMPTY_CART': {
      const items: IOrderProduct[] = [];
      localStorage.setItem('items', JSON.stringify(items));
      return {
        ...state,
        items,
      };
    }

    default:
      return state;
  }
}
